module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/MANAGEMENT-BUSINESS ADMINISTRATION-eb1aff6269d3f589f4e9da2a9b8be6e7.png";